import { PropsWithChildren } from 'react'
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components'
import merge from 'lodash/merge'

import theme from '@/theme/theme'

type TThemeProviderProps = PropsWithChildren<{
  customTheme?: unknown
}>

/**
 * @description
 * ThemeProvider is a wrapper component that provides a theme to all React components underneath itself via the context API.
 * It should preferably be used at the root of your component tree.
 *
 * @notes
 * ThemeProvider merges the theme object you provide with the default theme object.
 * It's possible to have a dark theme toggle in this component in the future.
 */
const ThemeProvider = ({ children, customTheme }: TThemeProviderProps) => {
  const modifiedTheme = merge(theme, customTheme)

  return <StyledComponentsThemeProvider theme={modifiedTheme}>{children}</StyledComponentsThemeProvider>
}

export default ThemeProvider
